export default function displayAsDateAndTime(value: string) {
    if(!value) return "";
    return new Intl.DateTimeFormat("en-US", { month: "2-digit",  day: "2-digit", year: "numeric", hour:"numeric", minute:"2-digit", hour12:true}).format(new Date(value));
}

